import { useOutletContext } from 'react-router-dom'
import { type Sobreaviso } from 'service/api'

export function useSobreavisoOutletContext() {
    return useOutletContext<{
        data?: Sobreaviso[]
    }>()
}
